import { render, staticRenderFns } from "./RecipeKeyword.vue?vue&type=template&id=70ea94a9&scoped=true"
import script from "./RecipeKeyword.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeKeyword.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeKeyword.vue?vue&type=style&index=0&id=70ea94a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea94a9",
  null
  
)

export default component.exports